export const GET_DASHBOARD_TIME = "dashboard/time";
export const GET_DASHBOARD_MESSAGE_TO_BOT = "dashboard/messageToBot";
export const GET_DASHBOARD_MESSAGE_UNANSWERED = "dashboard/messageUnanswered";
export const GET_LIST_DIVISION="dashboard/divisions";
export const GET_DASHBOARD_NOTIFICATION="/notifications";
export const GET_PMS_LIST = id => `dashboard/divisions/${id}/pm`;
export const UPDATE_READ = `update-read`;
export const UPDATE_VIEW = `update-view`;
export const GET_TOTAL_NOTIFICATION = id =>`/total/notifications?user_id=${id}`;
